import Vue from "vue";
import router from "./router";
import accounting from "accounting";
import pluralize from "pluralize";
import App from "./App";
import store from "./store";
import layout from "./components/shared/layout.vue";
import FullLayout from "./components/shared/FullLayout.vue";
import mobileLayout from "./components/shared/mobileLayout.vue";
import VeeValidate from "vee-validate";
import { veeCustomMessage } from "./validation/dictionary";
import { DetectMobile } from "./mixins/detectmobile";
import { DetectWC } from "./mixins/wcDetector";
import { DetectVersion } from "./mixins/versionDetector";
import { DetectBrand } from "./mixins/brandDetector";
import { formatCard } from "./filters/formatCard";
import { camelCase } from "./filters/camelCase";
import VueLazyload from "vue-lazyload";
import { logger } from "./api/Logger.js";
import { veeCustomValidator } from "./validation/GeneralValidators";
import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(VueQrcodeReader);
Vue.use(VueLazyload);
Vue.mixin(DetectMobile);
Vue.mixin(DetectWC);
Vue.mixin(DetectBrand);
Vue.mixin(DetectVersion);
Vue.use(VeeValidate, {
  dictionary: veeCustomMessage,
  errorBagName: "OOErrors"
});
veeCustomValidator.init(VeeValidate);
Vue.component("default-layout", layout);
Vue.component("full-layout", FullLayout);
Vue.component("mobile-layout", mobileLayout);
require("./assets/bootstrap/scss/bootstrap.scss");
require("./assets/main.scss");
require("./assets/main.mobile.scss");
require("jquery");
var Rollbar = require("vue-rollbar");
Vue.use(Rollbar, {
  accessToken: "461e1804c81e418686116b569d2d8109",
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  source_map_enabled: true,
  environment: "production",
  payload: {
    client: {
      javascript: {
        code_version: "1.0"
      }
    }
  }
});
require("popper.js");
require("bootstrap");
Vue.config.productionTip = false;

Vue.filter("formatMoney", accounting.formatMoney);
Vue.filter("pluralize", pluralize);
Vue.filter("formatCard", formatCard);
Vue.filter("camelCase", camelCase);
Vue.filter("formatNumber", function(value) {
  return new Intl.NumberFormat().format(value);
});
if (process.env.NODE_ENV === "production") {
  Vue.config.errorHandler = function(err, vm, info) {
    let handler,
      current = vm;
    logger.log(info, err.message, vm.$vnode.tag, logger.LogType.Error);
    if (vm.$options.errorHandler) {
      handler = vm.$options.errorHandler;
    } else {
      while (current.$parent) {
        current = current.$parent;
        if ((handler = current.$options.errorHandler)) break;
      }
    }
    if (handler) handler.call(current, err, vm, info);
    // else router.replace({ name: "generalError" });
  };
  Vue.config.warnHandler = function(err, vm, info) {
    let tag = vm && vm.$vnode ? vm.$vnode.tag : "";
    logger.log(info, err, tag, logger.LogType.Warning);
  };
}
new Vue({
  el: "#shop",
  router: router,
  store,
  render: h => h(App)
});
